<h2>Home </h2>
@if (home) {
  <form (ngSubmit)="submitForm()" [formGroup]="formHome" novalidate class="mt-2">
    <div class="form-group">
      <label>Título</label>
      <input id="titulo" formControlName="titulo" type="text" class="form-control" required />
      @if (submitted && f.titulo.errors) {
        <small class="text-danger">
          @if (f.titulo.errors.required) {
            <span>Título é obrigatório.</span>
          }
        </small>
      }
    </div>
    <div class="form-group">
      <label>Texto Principal</label>
      <editor [init]="{ plugins: 'lists link image table code help wordcount', height: 400}"
      apiKey="ucebs9h257hi0y65mcmhki93g8yo59prz68898ozeadwxn04" formControlName="textoPrincipal" id="texto"></editor>
      @if (submitted && f.textoPrincipal.errors) {
        <small class="text-danger">
          @if (f.textoPrincipal.errors.required) {
            <span>Texto Principal é obrigatório.</span>
          }
        </small>
      }
    </div>
    <div class="form-group">
      <label>Texto Sobre</label>
      <editor [init]="{ plugins: 'lists link image table code help wordcount', height: 400}"
      apiKey="ucebs9h257hi0y65mcmhki93g8yo59prz68898ozeadwxn04" formControlName="textoSobre" id="textoSobre"></editor>
      @if (submitted && f.textoSobre.errors) {
        <small class="text-danger">
          @if (f.textoSobre.errors.required) {
            <span>Texto Sobre é obrigatório.</span>
          }
        </small>
      }
    </div>
    <div class="form-group">
      <label>Foto</label>
      <input id="foto" formControlName="foto" type="text" class="form-control" required />
      @if (submitted && f.foto.errors) {
        <small class="text-danger">
          @if (f.foto.errors.required) {
            <span>Foto é obrigatório.</span>
          }
        </small>
      }
    </div>
    <div class="form-group">
      <label>Linkedin</label>
      <input id="linkedin" formControlName="linkedin" type="text" class="form-control" required />
      @if (submitted && f.linkedin.errors) {
        <small class="text-danger">
          @if (f.linkedin.errors.required) {
            <span>Linkedin é obrigatório.</span>
          }
        </small>
      }
    </div>
    <div class="form-group">
      <label>GitHub</label>
      <input id="gitHub" formControlName="gitHub" type="text" class="form-control" required />
      @if (submitted && f.gitHub.errors) {
        <small class="text-danger">
          @if (f.gitHub.errors.required) {
            <span>GitHub é obrigatório.</span>
          }
        </small>
      }
    </div>
    <div class="form-group">
      <label>Twitter</label>
      <input id="twitter" formControlName="twitter" type="text" class="form-control" required />
      @if (submitted && f.twitter.errors) {
        <small class="text-danger">
          @if (f.twitter.errors.required) {
            <span>Twitter é obrigatório.</span>
          }
        </small>
      }
    </div>
    <button type="submit" class="btn btn-sm-text btn-sm btn-success me-2">Salvar</button>
    <button type="button" class="btn btn-sm-text btn-sm btn-warning" (click)="reloadCurrentPage()">Cancelar</button>
    <input type="hidden" formControlName="id" name="id" id="id" />
  </form>
}